import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import "../nav2.css"
export default function Nav2() {
  const [dropdownVisible, setDropdownVisible] = useState({
    adult: false,
    kids: false,
    services: false,
    contact: false,
  });
  const [translateX, setTranslateX] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [hovered, setHovered] = useState(null);
  const navRef = useRef(null);
  const speed = 0.3;

  
  // Detect screen width
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setDropdownVisible({ adult: false, kids: false, services: false, contact: false });
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = (menu) => {
    setDropdownVisible((prevState) => ({
      adult: menu === "adult" ? !prevState.adult : false,
      kids: menu === "kids" ? !prevState.kids : false,
      services: menu === "services" ? !prevState.services : false,
      contact: menu === "contact" ? !prevState.contact : false,
    }));
  };

  const closeAllDropdowns = () => {
    setDropdownVisible({ adult: false, kids: false, services: false, contact: false });
  };

  const images = [
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925257/my_uploads/ebb2kmka35ybvpqg7jkp.png",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925346/my_uploads/xngdoisnj4aehhctngrd.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925348/my_uploads/qfgusdjx9jfatj33s8ip.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925349/my_uploads/moussynptvgmftk8tbbe.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925351/my_uploads/bddnzlvjrgb8adbtpw4z.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925269/my_uploads/weqxtgqjiq6bjtg5hn3o.png",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925354/my_uploads/jlxhto080y2dwqpwud6f.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925355/my_uploads/lo8htnkxmhdcboyuykwv.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925358/my_uploads/gvhdkypj98hdnje8knyg.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925258/my_uploads/qexkbjdupkgteslfjtnt.png",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925258/my_uploads/j38etcxayfq8vdoor97g.png",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925360/my_uploads/pntieytfmiuwva1crzju.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925361/my_uploads/sizxbd7vqshuy06lw92p.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925361/my_uploads/hmom0xxukv86p4leyf8m.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925238/my_uploads/ukfdoehcmjy5fbtizlk8.png",
  ];

  // Scrolling logos
  useEffect(() => {
    const interval = setInterval(() => {
      setTranslateX((prev) => (prev <= -images.length * 200 ? 0 : prev - speed));
    }, 20);
    return () => clearInterval(interval);
  }, []);

  const dropdownPositionStyle = isMobile
    ? { left: 0, transform: "none", minWidth: "140px" }
    : { left: "50%", transform: "translateX(-50%)", minWidth: "160px" };

  return (
    <>
      <nav style={styles.nav} ref={navRef}>
        <ul style={styles.navList}>
          {/* Kids Menu */}
          <li
            style={{ ...styles.navItem, ...(hovered === "kids" && styles.navItemHover) }}
            onMouseEnter={() => setHovered("kids")}
            onMouseLeave={() => setHovered(null)}
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown("kids");
            }}
          >
            Kids
            {dropdownVisible.kids && (
              <div style={{ ...styles.dropdownMenu, ...dropdownPositionStyle }}>
                <Link to="/kids-apparel-list" style={styles.dropdownLink} className="dropdownLink">Apparel</Link>
                <Link to="/kids-accessories-list" style={styles.dropdownLink} className="dropdownLink">Accessories</Link>
                <Link to="/kidsBlanks" style={styles.dropdownLink} className="dropdownLink">Blanks</Link>
                <Link to="/kids-apparel-list-white" style={styles.dropdownLink} className="dropdownLink">Garment Coloring</Link>
                <Link to="/kids-gallery" style={styles.dropdownLink} className="dropdownLink">Art Gallery</Link>
              </div>
            )}
          </li>

          {/* Adult Menu */}
          <li
            style={{ ...styles.navItem, ...(hovered === "adult" && styles.navItemHover) }}
            onMouseEnter={() => setHovered("adult")}
            onMouseLeave={() => setHovered(null)}
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown("adult");
            }}
          >
            Adult
            {dropdownVisible.adult && (
              <div style={{ ...styles.dropdownMenu, ...dropdownPositionStyle }}>
                <Link to="/adult-apparel" style={styles.dropdownLink} className="dropdownLink">Apparel</Link>
                <Link to="/accessories-adult" style={styles.dropdownLink} className="dropdownLink">Accessories</Link>
                <Link to="/adultsBlanks" style={styles.dropdownLink} className="dropdownLink">Blanks</Link>
                <Link to="/adults-gallery" style={styles.dropdownLink} className="dropdownLink">Art Gallery</Link>
              </div>
            )}
          </li>

          {/* Services Menu */}
          <li
            style={{ ...styles.navItem, ...(hovered === "services" && styles.navItemHover) }}
            onMouseEnter={() => setHovered("services")}
            onMouseLeave={() => setHovered(null)}
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown("services");
            }}
          >
            Services
            {dropdownVisible.services && (
              <div style={{ ...styles.dropdownMenu, ...dropdownPositionStyle }}>
                <Link to="/services/screen-printing" style={styles.dropdownLink} className="dropdownLink">Screen Printing</Link>
                <Link to="/services/laser-etching" style={styles.dropdownLink} className="dropdownLink">Laser Etching</Link>
                <Link to="/services/embroidery" style={styles.dropdownLink} className="dropdownLink">Embroidery</Link>
                
                <Link to="/services/patches" style={styles.dropdownLink} className="dropdownLink">Patches</Link>
              </div>
            )}
          </li>

          {/* Contact Us */}
          <li
            style={{ ...styles.navItem, ...(hovered === "contact" && styles.navItemHover) }}
            onMouseEnter={() => setHovered("contact")}
            onMouseLeave={() => setHovered(null)}
          >
            <Link to="/about-us" style={styles.navLink} onClick={closeAllDropdowns}>
              About Us
            </Link>
          </li>
        </ul>
      </nav>

      {/* Image Slider */}
      <div className="overflow-hidden w-full bg-gray-100 py-1">
        <div
          className="flex items-center flex-nowrap gap-8"
          style={{
            display: "flex",
            flexWrap: "nowrap",
            whiteSpace: "nowrap",
            transform: `translateX(${translateX}px)`,
            transition: "transform 0s linear",
            marginBottom: 5,
          }}
        >
          {[...images, ...images].map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`Logo ${index + 1}`}
              className="mx-2"
              style={{
                height: "110px",
                width: "170px",
                flexShrink: 0,
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
}

const styles = {
  nav: {
    backgroundImage: "linear-gradient(to right, #A60065, #071d49)",
    padding: "5px",
    borderRadius: "8px",
    position: "relative",
    zIndex: 900,
  },
  navList: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    listStyleType: "none",
    margin: 0,
    padding: 0,
  },
  navItem: {
    width: "25%",
    textAlign: "center",
    position: "relative",
    color: "white",
    transition: "background-color 0.3s ease, color 0.3s ease",
    fontSize: "16px",
    cursor: "pointer",
    padding: "4px 0",
  },
  navItemHover: {
    background: "linear-gradient(to right, #A60065, #071d49)",
    borderRadius: "8px",
    color: "white",
  },
  navLink: {
    color: "#fff",
    textDecoration: "none",
    fontSize: "16px",
    display: "block",
    padding: "4px",
    whiteSpace: "nowrap",
  },
  dropdownMenu: {
    marginTop: 5,
    borderRadius: 10,
    position: "absolute",
    top: "100%",
    backgroundImage: "linear-gradient(to right, #071d49, #A60065)",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
    color: "#f5efe3",
  },
  dropdownLink: {
    display: "block",
    padding: "6px 14px",
    textDecoration: "none",
    color: "#f5efe3",
    fontSize: "14px",
  },
};
